import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { LogOut, Plus, Shield } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '../ui/dropdown-menu';

export const AppHeader = ({ showNewProject = true }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-border" data-testid="app-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate('/dashboard')}
          data-testid="app-header-logo"
        >
          <img
            src="/jiofinance-logo.svg"
            alt="JioFinance"
            className="w-9 h-9"
          />
          <span className="font-heading font-bold text-lg tracking-tight hidden sm:inline">
            JioFinance <span className="font-medium text-muted-foreground">Avatar Studio</span>
          </span>
        </div>

        <nav className="flex items-center gap-3" data-testid="app-header-nav">
          {showNewProject && (
            <Button
              onClick={() => navigate('/projects/new')}
              size="sm"
              className="rounded-xl gap-1.5 shadow-sm"
              data-testid="dashboard-new-project-button"
            >
              <Plus className="w-4 h-4" />
              <span className="hidden sm:inline">New project</span>
            </Button>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="flex items-center gap-2 px-2 py-1.5 rounded-xl hover:bg-secondary transition-colors"
                data-testid="app-header-user-menu"
              >
                <div className="w-8 h-8 rounded-full bg-[hsl(38,78%,56%)]/15 flex items-center justify-center text-sm font-semibold text-[hsl(38,78%,45%)]">
                  {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                </div>
                <span className="text-sm font-medium hidden md:inline">{user?.name}</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <div className="px-2 py-1.5">
                <p className="text-sm font-medium">{user?.name}</p>
                <p className="text-xs text-muted-foreground">{user?.email}</p>
              </div>
              <DropdownMenuSeparator />
              {user?.is_admin && (
                <DropdownMenuItem
                  onClick={() => navigate('/admin')}
                  className="cursor-pointer"
                  data-testid="admin-panel-link"
                >
                  <Shield className="w-4 h-4 mr-2" />
                  Admin Panel
                </DropdownMenuItem>
              )}
              <DropdownMenuItem
                onClick={handleLogout}
                className="text-red-600 cursor-pointer"
                data-testid="logout-button"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>
      </div>
    </header>
  );
};
